import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ValidationService } from 'src/app/services/validation/validation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-group-voicemail',
  templateUrl: './group-voicemail.component.html',
  styleUrls: ['./group-voicemail.component.css']
})
export class GroupVoicemailComponent implements OnInit {

  lambdaError: boolean = false;
  lambdaMessage: string = '';
  group_data: Array<any> = [];
  group_filteredData: Array<any> = [];
  modeIsEdit: boolean = false;
  lobList: Array<any> = []
  lobSelect: string = "";

  formValid: boolean = false;
  
  didList: Array<any> = [];
  didOptions: Array<string> = [];

  bluePrint = {
    cc: "",
    deliveryEmail: true,
    deliveryOptions: {
      email: true,
      sms: {
        enabled: false,
        phoneNumber: "null"
      }
    },
    encryptVoicemail: false,
    transcribeVoicemail: true,
    DID: "",
    emailAddress: "",
    greeting: "",
    groupName: "",
    LOB: "",
    housekeeping: {
      lastUpdatedBy: "",
      createdBy: ""
    }
  }​​​​​

  constructor(private telecomService:TelecomService, private auth:AuthService, private validationService:ValidationService) { }

  ngOnInit(): void {
    this.getLOBs();
    this.getGroupVoicemail();
  }
  
  getLOBs() {
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobList = resultData.lobList;
    });
  }

  getGroupVoicemail() {
    const params = {
      FunctionName: environment.GetAllGroupVoicemailLambdaName,
      Payload: JSON.stringify({})
    };
    this.telecomService.callLambda(params, "Failed to retrieve voicemail groups").then((response: any) => {
      this.group_data = response;
      this.group_applyFilter();
      this.getDIDs();
    }, error => {
      this.lambdaError = true;
      this.lambdaMessage = "Failed to retrieve voicemail groups.";
    });
  }

  getDIDs() {
    const params = {
      FunctionName: environment.GetConnectDIDListLambdaName,
      Payload: JSON.stringify({ operation: "get" })
    }
    this.telecomService.callLambda(params, "Failed to retrieve DID's").then((response: any) => {
      this.didList = response.map(x => x.PhoneNumber);;
      this.fitlerDIDs();
    }, err => {
      this.lambdaError = true;
      this.lambdaMessage = ""
    });
  }

  fitlerDIDs() {
    console.log("filtering available DIDs");
    let temp = JSON.parse(JSON.stringify(this.didList));
    for (let x = 0; x < temp.length; x++) {
      for (let y = 0; y < this.group_data.length; y++) {
        if (temp[x] === this.group_data[y].DID) {
          temp.splice(x, 1);
          x--;
        }
      }
    }
    this.didOptions = JSON.parse(JSON.stringify(temp));
  }

  group_applyFilter() {
    console.log("filtering groups");
    let temp = [];
    for (let x = 0; x < this.group_data.length; x++) {
      if (this.group_data[x].hasOwnProperty("LOB")) {
        if (this.group_data[x].LOB.startsWith(this.lobSelect)) {
          temp.push(this.group_data[x]);
        }
      } else if (this.lobSelect == "") {
        temp.push(this.group_data[x]);
      }
    }
    this.group_filteredData = JSON.parse(JSON.stringify(temp));
  }

  setExtension(evt: any, item: any) {
    item.extension = evt.value;
  }

  group_validate(item) {
    this.lambdaMessage = '';
    this.lambdaError = false;

    if (item.groupName.length < 3) {
      this.lambdaError = true;
      this.lambdaMessage = "Group names must have be three or more characters"
      return false;
    }

    if (item.DID.length < 8) {
      this.lambdaError = true;
      this.lambdaMessage = "Extensions must have seven or more digits"
      return false;
    }

    if (item.emailAddress.length < 1) {
      this.lambdaError = true;
      this.lambdaMessage = "Email is required";
      return false;
    }
    if (!this.validationService.validEmail(item.emailAddress)) {
      this.lambdaError = true;
      this.lambdaMessage = "Invalid email address"
      return false;
    }
    if (!this.validationService.validEmail(item.cc) && item.cc.trim() != "") {
      this.lambdaError = true;
      this.lambdaMessage = "Invalid CC address";
      return false;
    }

    if (item.LOB === "") {
      this.lambdaError = true;
      this.lambdaMessage = "LOB is required"
      return false;
    }
    return true;
  }

  group_handleItemChange(evt: any) {
    if (evt.button === "confirm") {
      //make sure item has essential fields
      let item = evt.item;
      item.housekeeping.lastUpdatedBy = this.auth.currentUser;
      if (item.housekeeping.createdBy === "") {
        item.housekeeping.createdBy = this.auth.currentUser;
      }
      if (item.hasOwnProperty('lastUpdated')) {
        delete item.lastUpdated;
      }
      if (item.hasOwnProperty('createDate')) {
        delete item.createDate;
      }
      console.log("finished item: ", item);
      //call lambda to update
      let event = {
        groupVoicemail: item,
      }
      if (this.modeIsEdit) {
        event['operation'] = 'Update'
      } else {
        event['operation'] = 'Insert'
      }
      const params = {
        FunctionName: environment.UpdateGroupVoicemailLambdaName,
        Payload: JSON.stringify(event)
      };
      this.telecomService.callLambda(params, "Failed to update group voicemail").then((response: any) => {
        console.log("update response: ", response);
        if (response.hasOwnProperty("Attributes")) {    //success
          let found = false;
          for (let x = 0; x < this.group_data.length; x++) {
            if (this.group_data[x].DID == response.Attributes.DID) {
              this.group_data[x] = response.Attributes;
              console.log("match found, updating local data");
              found = true;
              break;
            }
          }
          if (!found) {
            console.log("no match found, appending to local data");
            this.group_data.unshift(response.Attributes);
          }
          this.lambdaMessage = "Group updated successfully"
        } else {
          this.lambdaError = true;
          this.lambdaMessage = "Failed to update group voicemail"
        }
        this.group_applyFilter();
        this.fitlerDIDs();
      });
    } else if (evt.button == "delete") {
      //call lambda to delete
      const params = {
        FunctionName: environment.DeleteGroupVoicemailLambdaName,
        Payload: JSON.stringify(evt.item)
      };
      this.telecomService.callLambda(params, "Failed to delete group voicemail").then((response: any) => {
        console.log("delete response: ", response);
        if (response !== null) {
          this.lambdaError = false;
          this.lambdaMessage = 'Group deleted successfully'
        } else {
          this.lambdaError = true;
          this.lambdaMessage = "Failed to delete group voicemail"
        }
        this.getGroupVoicemail();
      });
    }
  }

  group_handleButtonEvent(evt: any) {
    this.modeIsEdit = (evt == 'edit');
    this.lambdaError = false;
    this.lambdaMessage = "";
  }

  handleButtonEvent(evt: any){
    console.log(evt);
    if(evt.button == "confirm"){
      
    }
  };
}
